<a *inDevMode mat-button style="background-color: red; color:white">
  <mat-icon>donut_small</mat-icon>
  DEV
</a>
<!--
<a *needOfficeAuth mat-button style="background-color: red; color:white" (click)="o365auth()">
  <mat-icon>domain_disabled</mat-icon>
  Achtung: O365 Anmeldung Erforderlich
</a>
-->
@if (authService.currentUser) {
  <a routerLinkActive="active" mat-button [matMenuTriggerFor]="user">
    <mat-icon>account_circle</mat-icon>
    {{ authService.currentUser.login }}
    <mat-menu [overlapTrigger]=" false" #user="matMenu" class="full-width-menu">
      <a class="logoutbtn" routerLinkActive="active" mat-menu-item routerLink="/logout">
        <mat-icon>logout</mat-icon>
        Logout
      </a>
      <mat-divider></mat-divider>
      @for (r of authService.currentUser.roles; track r) {
        <div mat-menu-item class="role-item">
          {{ r }}
        </div>
      }
    </mat-menu>
  </a>
}
<a mat-button (click)="sendFeedback()">
  <mat-icon>feedback</mat-icon>
</a>
